"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownSelect = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownSelectMixin = require("../../mixins/components/DropdownSelectMixin");
var _Combobox = require("../Combobox/Combobox");
/**
 * If you are not customizing options with `appearance`, `icons`, or `meta` from
 * ListboxOption, or using a multiselectable dropdown,
 * then it is better to use the Select component because
 * mobile browsers will optimize the user interaction.

 * @extends Combobox
 * @since 8.28.0
 */

var DropdownSelect = /*#__PURE__*/(0, _styledComponents.default)(_Combobox.Combobox).withConfig({
  displayName: "DropdownSelect",
  componentId: "c11n-8-101-0__sc-8nfqab-0"
})(["", ""], _DropdownSelectMixin.DropdownSelectMixin);
exports.DropdownSelect = DropdownSelect;
DropdownSelect.displayName = 'DropdownSelect';
DropdownSelect.propTypes = {
  /**
   * @ignore
   */
  editable: _propTypes.default.bool,
  /**
   * The value of the select when used as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   *
   * This should be a string, or an array of strings for a multiselectable select.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  /**
   * The value of the select when used as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   *
   * This should be a string, or an array of strings for a multiselectable select.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  /**
   * An array of options, or an array of optgroups that will be passed to the
   * Listbox dialog. See Listbox for more information.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  options: _propTypes.default.array,
  /**
   * Sometimes we need to render the input's dropdown outside of the parent, if so, set to `true`
   * and the dropdown will render as a direct child of the `body` element
   *
   * @default false
   */
  isDropdownPortal: _propTypes.default.bool
};
DropdownSelect.defaultProps = {
  editable: false
};

/** @component */